module.exports = __webpack_public_path__ + "img/father_and_kid_sea.dbf0516a.jpg";